module.exports = __webpack_public_path__ + "static/history03_02-80f426d1e8c613ff3bec310460a0cd5c.png";